<template>
    <v-container
            id="store-new"
            fluid
            tag="section"
    >
        <v-card :loading="loading">
            <v-card-title class="black white--text">
                <span class="headline">Création d'une boutique</span>
            </v-card-title>

            <v-form ref="form" v-model="valid">
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" md="12">
                            <h2>{{ $t('store.store_informations') }}</h2>
                        </v-col>

                        <v-col
                                cols="12"
                                md="4"
                        >
                            <v-text-field
                                    :label="$t('global.name')"
                                    :rules="[rules.required]"
                                    v-model="store.name"
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            md="4"
                        >
                            <v-text-field
                                :label="$t('global.short_name')"
                                :rules="[rules.required]"
                                v-model="store.short_name"
                                hint="Le nom de la boutique qui s'affichera sur Imparfaite"
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            md="4"
                        >
                            <v-select
                                v-model="store.kind"
                                :items="store_kinds"
                                item-text="label"
                                item-value="value"
                                clearable
                                label="Type"
                                :rules="[rules.required]"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" >
                            <h2>{{ $t('store.seller_informations') }}</h2>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    :label="$t('global.first_name')"
                                    :rules="[rules.required]"
                                    v-model="store.owner.first_name"
                            />
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    :label="$t('global.last_name')"
                                    :rules="[rules.required]"
                                    v-model="store.owner.last_name"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    :label="$t('global.email')"
                                    :rules="[rules.required]"
                                    v-model="store.owner.email"
                            />
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    :label="$t('global.phone')"
                                    :rules="[rules.required]"
                                    v-model="store.owner.phone"
                            />
                        </v-col>
                    </v-row>
                    <v-row>

                        <v-col cols="12" sm="6">
                            <v-text-field
                                    :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min]"
                                    :type="show_password ? 'text' : 'password'"
                                    label="Mot de passe"
                                    hint="At least 8 characters"
                                    class="input-group--focused"
                                    v-model="store.owner.password"
                                    @click:append="show_password = !show_password"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field
                                    :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.passwordMatch]"
                                    :type="show_password ? 'text' : 'password'"
                                    label="Mot de passe (confirmation)"
                                    hint="At least 8 characters"
                                    v-model="store.owner.repassword"
                                    @click:append="show_password = !show_password"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-col
                            cols="12"
                    >
                        <v-btn
                                @click="save"
                                color="primary"
                        >
                            <template>{{ $t('store.save_store') }}</template>
                        </v-btn>
                    </v-col>
                </v-container>
            </v-form>
        </v-card>
        <v-snackbar
                v-model="snackbar"
                :color="color"
        >
            {{ message }}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                {{ $t('global.close') }}
            </v-btn>
        </v-snackbar>
    </v-container>
</template>
<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'Store',

        beforeMount() {
            this.load();
        },

        data() {
            return {
                store_kinds: [
                    {label:'Passionné', value:'PASSIONATE'},
                    {label:'Pro Online', value:'PRO_ONLINE'},
                    {label:'Pro Offline', value:'PRO_OFFLINE'},
                ],
                show_password: false,
                snackbar: false,
                color: 'info',
                message: '',
                store: {
                    owner: {},
                },
                valid: false,
                loading: false,
                rules: {
                    required: value => !!value || this.$i18n.t('global.required'),
                    min: v => v.length >= 8 || 'Min 8 characters',
                    passwordMatch: (v) => v === this.store.owner.password || this.$i18n.t('global.passwords_mismatch'),
                },
            };
        },

        methods: {
            save() {
                this.$refs.form.validate();
                if (!this.valid) return false;

                this.loading = true;
                this.$axios.post('stores', this.store)
                    .then(response => {
                        this.loading = false;
                        this.store = response.data;
                        this.snackbar = true;
                        this.message = this.$i18n.t('store.store_saved');
                        this.color = 'info';
                        this.$router.push({name: 'Store', params: {id: this.store.id}});
                    })
                    .catch(() => {
                        this.loading = false;
                        this.snackbar = true;
                        this.message = this.$i18n.t('store.store_save_failed');
                        this.color = 'error';
                });
            }
        },

        computed: {
            ...mapGetters(['isSeller']),
        },
    }
</script>
